import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  end,
  suffix = '',
  prefix = ''
}: {
  end: number;
  suffix?: string;
  prefix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const started = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        let start = 0;
        const duration = 2000;
        const step = (ts: number) => {
          if (!start) start = ts;
          const p = Math.min((ts - start) / duration, 1);
          const e = 1 - Math.pow(1 - p, 4);
          setCount(Math.floor(e * end));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      }
    }, {
      threshold: 0.3
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end]);
  return <div ref={ref} data-id="element-574">
      {prefix}
      {count.toLocaleString()}
      {suffix}
    </div>;
}
const stats = [{
  value: 80,
  suffix: 'M+',
  prefix: '$',
  label: 'GMV Transacted',
  sub: 'Across all marketplace trades',
  icon: '📦'
}, {
  value: 5,
  suffix: 'M+',
  prefix: '$',
  label: 'Valuation',
  sub: 'Post Shark Tank funding',
  icon: '🦈'
}, {
  value: 5,
  suffix: '+',
  prefix: '',
  label: 'Countries',
  sub: 'India, Bangladesh & more',
  icon: '🌏'
}, {
  value: 1000,
  suffix: '+',
  prefix: '',
  label: 'Active Buyers',
  sub: 'Mills, traders & exporters',
  icon: '🏭'
}];
export function Stats() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.section ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.6
  }} className="py-24 bg-[#FAFAF8] woven-bg" data-id="element-575">
      <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-576">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-577">
          <p className="text-xs font-inter font-semibold text-[#E8500A] tracking-[0.18em] uppercase mb-4" data-id="element-578">
            By The Numbers
          </p>
          <h2 className="font-jakarta text-4xl md:text-5xl font-extrabold text-[#0F0E0C] mb-3 leading-tight" data-id="element-579">
            Numbers that speak.
          </h2>
          <p className="text-[#5C5A55] font-inter max-w-md mx-auto text-base" data-id="element-580">
            Built on years of deep industry relationships and technology-first
            thinking.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 relative" data-id="element-581">
          {stats.map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20,
          filter: 'blur(4px)'
        }} animate={isInView ? {
          opacity: 1,
          y: 0,
          filter: 'blur(0px)'
        } : {}} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} whileHover={{
          y: -3,
          transition: {
            duration: 0.2
          }
        }} className="bg-white rounded-2xl p-7 border border-[#E8E4DC] hover:border-[#D4CFC5] hover:shadow-lg hover:shadow-black/5 transition-all duration-300 cursor-default" data-id="element-582">
              <div className="text-2xl mb-3" data-id="element-583">{stat.icon}</div>
              <div className="font-jakarta text-4xl md:text-5xl font-extrabold text-[#0F0E0C] mb-1.5" data-id="element-584">
                <Counter end={stat.value} suffix={stat.suffix} prefix={stat.prefix} data-id="element-585" />
              </div>
              <div className="font-inter font-semibold text-sm text-[#0F0E0C] mb-1" data-id="element-586">
                {stat.label}
              </div>
              <div className="text-xs text-[#9B9890] font-inter" data-id="element-587">
                {stat.sub}
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.section>;
}